import { Flex, Text, ModalContent, styled } from '@grupoboticario/flora-react';

const styles = {
  ModalContent: styled(ModalContent, {
    '@tablet': {
      borderRadius: '$large',
    },
  }),

  Content: styled(Flex, {
    alignItems: 'center',

    '@tablet': {
      alignItems: 'initial',
    },
  }),

  ButtonWrapper: styled(Flex, {
    flexDirection: 'column',

    '@tablet': {
      flexDirection: 'row',
    },
  }),

  InfoWrapper: styled(Flex, {
    gap: '$4',

    '@tablet': {
      gap: '$8',
    },
  }),

  Info: styled(Text, {
    textAlign: 'center',

    '@tablet': {
      textAlign: 'left',
    },
  }),
};

export default styles;
